import React from 'react'

export const PlaysSkeletonLoader: React.FC = () => {
  return (
    <div className="mt-8 space-y-4">
      {/* First skeleton card */}
      <div className="p-4 rounded-xl border border-app-grey-30 shadow-sm min-h-[100px] animate-pulse">
        <div className="space-y-3">
          {/* Title skeleton - large horizontal rectangle */}
          <div className="h-5 bg-app-grey-20 rounded w-3/4"></div>
          {/* Two smaller squares (badges) */}
          <div className="flex items-center gap-2">
            <div className="h-6 bg-app-grey-20 rounded-full w-16"></div>
            <div className="h-6 bg-app-grey-20 rounded-full w-20"></div>
          </div>
          {/* Description skeleton - horizontal rectangle */}
          <div className="h-4 bg-app-grey-20 rounded w-full"></div>
          {/* Footer with three small rectangles and three circles */}
          <div className="flex items-center justify-between mt-3">
            <div className="flex items-center gap-2">
              {/* Three small horizontal rectangles */}
              <div className="h-3 bg-app-grey-20 rounded w-12"></div>
              <div className="h-3 bg-app-grey-20 rounded w-16"></div>
              <div className="h-3 bg-app-grey-20 rounded w-10"></div>
            </div>
            <div className="flex items-center gap-2">
              {/* Three small circles */}
              <div className="h-4 w-4 bg-app-grey-20 rounded-full"></div>
              <div className="h-4 w-4 bg-app-grey-20 rounded-full"></div>
              <div className="h-4 w-4 bg-app-grey-20 rounded-full"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Second skeleton card */}
      <div className="p-4 rounded-xl border border-app-grey-30 shadow-sm min-h-[100px] animate-pulse">
        <div className="space-y-3">
          {/* Title skeleton - large horizontal rectangle */}
          <div className="h-5 bg-app-grey-20 rounded w-3/4"></div>
          {/* Two smaller squares (badges) */}
          <div className="flex items-center gap-2">
            <div className="h-6 bg-app-grey-20 rounded-full w-16"></div>
            <div className="h-6 bg-app-grey-20 rounded-full w-20"></div>
          </div>
          {/* Description skeleton - horizontal rectangle */}
          <div className="h-4 bg-app-grey-20 rounded w-full"></div>
          {/* Footer with three small rectangles and three circles */}
          <div className="flex items-center justify-between mt-3">
            <div className="flex items-center gap-2">
              {/* Three small horizontal rectangles */}
              <div className="h-3 bg-app-grey-20 rounded w-12"></div>
              <div className="h-3 bg-app-grey-20 rounded w-16"></div>
              <div className="h-3 bg-app-grey-20 rounded w-10"></div>
            </div>
            <div className="flex items-center gap-2">
              {/* Three small circles */}
              <div className="h-4 w-4 bg-app-grey-20 rounded-full"></div>
              <div className="h-4 w-4 bg-app-grey-20 rounded-full"></div>
              <div className="h-4 w-4 bg-app-grey-20 rounded-full"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
